import React from 'react';
import { BodyContainer, ItemDescription } from './styles';
import {
  NotificationOption,
  NotificationOptionProps
} from './NotificationItem';

export type NotificationBodyProps = {
  description: string;
  options: NotificationOptionProps;
};

export const NotificationBody = ({
  description,
  options
}: NotificationBodyProps) => {
  return (
    <BodyContainer>
      <ItemDescription>{description}</ItemDescription>
      <NotificationOption type={options.type} content={options.content} />
    </BodyContainer>
  );
};
